export var FOCUS_GROUP = 'data-focus-lock';
export var FOCUS_DISABLED = 'data-focus-lock-disabled';
export var FOCUS_ALLOW = 'data-no-focus-lock';
export var FOCUS_AUTO = 'data-autofocus-inside';


//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/es2015/constants.js
// module id = 142
// module chunks = 0